import { useState, useEffect } from 'react'

export const useIntersection = (element: any, rootMargin: any) => {
  const [isVisible, setState] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
        ([entry]) => {
          setState(entry.isIntersecting);
        }, { rootMargin }
    );

    element.current && observer.observe(element.current);

    const curr = element.current
    
    return () => observer.unobserve(curr);
  }, [element, rootMargin]);

  return isVisible;
};